<template>
  <transition name="fade" appear>
    <div class="product-small" :itemscope="productScheme ? true : false" :itemtype="productScheme ? 'http://schema.org/Product' : false">
      <meta v-if="productScheme" itemprop="image" :content="productPhotoUrl">
      <meta v-if="productScheme" itemprop="sku" :content="item.id">
      <span v-if="productScheme" style="display:none;" itemprop="brand" itemscope itemtype="https://schema.org/Brand">
        <meta itemprop="name" :content="item.brand.name_eng">
      </span>
      <!-- <div class="item-hover-bg"></div> -->
      <div :class="badgeClass" class="badge" />
      <a v-if="linkToProduct" :href="linkToProduct" class="js-product" target="_self">
        <img
          v-if="item"
          :key="productPhotoUrl"
          v-lazy="{
            src: productPhotoUrl,
            loading: '/img/preloader.svg',
            throttleWait: 0,
          }"
          :alt="item.name"
          src="/img/preloader.svg"
        >
      </a>
      <img
          v-else
          :key="productPhotoUrl"
          v-lazy="{
            src: productPhotoUrl,
            loading: '/img/preloader.svg',
            throttleWait: 0,
          }"
          :alt="item.name"
          src="/img/preloader.svg"
      >
      <div class="catalog_title">
        <a v-if="linkToProduct && item" :href="linkToProduct" target="_self">
          {{ itemPrefix }}<br><span>{{ item.name }}</span>
        </a>
        <noindex>
          <button
            :class="favoriteButtonClasses(item.id)"
            class="catalog_fav"
            title="Добавить в «Любимое», чтобы посмотреть позже"
            @click="toggleFavorite(item.id)"
          >
            Нравится
          </button>
        </noindex>
        <meta v-if="productScheme" itemprop="name" :content="`${itemPrefix} ${item.name}`">
      </div>

      <meta v-if="productScheme && item" itemprop="description" :content="item.description || item.in_stock ? 'В наличии' : 'В начилии нет'">
      <ul class="catalog_meta_small" :itemprop="productScheme ? 'offers' : false" :itemscope="productScheme ? true : false" :itemtype="productScheme ? 'http://schema.org/Offer' : false">
        <li class="catalog_meta_price">
          {{ item.price | currency }}
          <div class="ruble-svg ruble-svg_small" aria-hidden="true" />
          <meta v-if="productScheme && item" :content="item.price" itemprop="price">
          <meta v-if="productScheme" itemprop="priceCurrency" content="RUB">
          <meta v-if="productScheme" itemprop="sku" :content="item.id">
          <meta v-if="productScheme" itemprop="priceValidUntil " :content="priceValidUntilDate">
          <meta v-if="productScheme && linkToProduct" itemprop="url" :content="linkToProduct">
          <link v-if="productScheme" itemprop="availability" href="http://schema.org/InStock">
        </li>
        <li v-if="styleProp && category" class="catalog_meta_style">
          <a :href="`/${category.slug}/?style=${styleProp.slug}`" target="_self">
            {{ styleProp.name }}
          </a>
        </li>
        <li v-if="category && item && item.brand" class="catalog_meta_brand">
          <a :href="`/${category.slug}/${item.brand.slug}/`" target="_self">
            {{ item.brand.name_eng }}
          </a>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-console */
import { IMAGE_URL, LAST_CATALOG_VERTICAL } from '@/assets/js/constants'
import { cookieStore } from '@/assets/js/storejs'
import analyticsMixin from '@/assets/mixins/analytics.mixin'

export default {
  name: 'CatalogItemSmall',
  mixins: [analyticsMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    styleProp: {
      type: Object,
      default: null
    },
    productScheme: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      imageURL: IMAGE_URL
    }
  },
  computed: {
    itemPrefix () {
      if (!this.category) return ''

      return this.category.item_prefix || this.item.categories[0].item_prefix
    },
    productPhotoUrl () {
      return `${this.imageURL}/uploads/item/1000-1500/${this.item.photo_main.hash}${this.item.photo_main.ext}`
    },
    favoriteItems () {
      return this.$store.state.favorite.items
    },
    favoriteButtonClasses () {
      return (id) => {
        return {
          'is-active heartBeat animated': this.favoriteItems.includes(id)
        }
      }
    },
    linkToProduct () {
      if (!this.category) return null

      let url = `/${this.category.slug}`

      if (this.item.brand) {
        url += `/${this.item.brand.slug}/${this.item.slug}/`
      } else {
        url += `/item/${this.item.id}/`
      }

      if (this.styleProp) {
        url += `${this.styleProp ? '?style=' + this.styleProp.slug : ''}`
      }

      return url
    },
    badgeClass () {
      return {
        badge__new: this.item.tags.some(tag => tag.name === 'New'),
        badge__hit: this.item.tags.some(tag => tag.name === 'Hit'),
        badge__sale: this.item.tags.some(tag => tag.name === 'Sale')
      }
    },
    priceValidUntilDate () {
      const today = new Date()
      const tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 10)

      return `${tomorrow.getFullYear()}-${(tomorrow.getMonth() + 1) >= 10 ? tomorrow.getMonth() + 1 : '0' + (tomorrow.getMonth() + 1)}-${tomorrow.getDate() >= 10 ? tomorrow.getDate() : '0' + tomorrow.getDate()}`
    }
  },

  methods: {
    onProductClick () {
      try {
        //localStorage.setItem(LAST_CATALOG_VERTICAL, window.pageYOffset)
        //cookieStore.set(LAST_CATALOG_VERTICAL, window.pageYOffset)
      } catch (error) {
        this.$sentry.captureException(error)
        // возможно приватный режим
        console.error('Error of local storage', error)
      }
    }
  }

}
</script>

<style lang="scss">
.product-small {
  .catalog_title {
    margin-top: 5px;
  }
  .catalog_fav {
    position: absolute;
    right: 5px;
    top: 50%;
    margin-top: -9px;
  }
}
.badge__hit {
  position: absolute;
}
.badge__new {
  position: absolute;
}
.badge__sale {
  position: absolute;
}

// .catalog_item__tall:hover {
//   .item-hover-bg {
//     background: #f6f6f6;
//     width: calc(100% + 11px);
//     height: calc(100% + 14px);
//     position: absolute;
//     top: -11px;
//     right: -11px;
//   }
// }

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
//   opacity: 0;
// }

// .catalog_item
//   .catalog_eximg.catalog_eximg__static
//   .catalog_eximg_container
//   ul
//   li {
//   height: 87px;
//   width: 58px;
//   background-color: #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   img:not([lazy='loaded']) {
//     width: 15px;
//   }
//   img:not([lazy='loaded']).selected {
//     outline: none;
//   }
// }

// .catalog_figure {
//   img:not([lazy='loaded']) {
//     width: 60px;
//   }
// }
</style>
